import {Component, Prop} from 'vue-property-decorator';
import * as tsx from 'vue-tsx-support';

import MenuButton from '@/components/Menu/MenuButton';
import Log from '@/components/Log'

interface IMenu {
  events?: object;
}

@Component
export default class Menu extends tsx.Component<IMenu> {
  
  @Prop() public events?: object
  
  render() {
    const {events} = this.$props;
    return (
      <div>
        <Log number='N0111'> <MenuButton click={() => events.routerPush('message')} iconName='msg' name='消息中心'/></Log>
        <Log number='N0112'> <MenuButton click={() => events.routerPush('order')} iconName='order' name='订单中心'/></Log>
        <Log number='N0121'> <MenuButton click={() => events.routerPush('customer')} iconName='customerCenter' name='联系客服'/></Log>
        <Log number='N0122'> <MenuButton style='visibility: hidden;' click={() => events.routerPush('bindPhoneNumber')} iconName='bind' name='绑定手机号'/></Log>
      </div>
    )
  }
  
}